import { TimePicker, message } from "antd"
import moment from "moment"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { IoTrashOutline } from "react-icons/io5"
import styled from "styled-components"

import AppButton from "../../../../../../_shared/components/AppButton"
import FloatingButton from "../../../../../../_shared/components/FloatingButton"
import DatePicker from "../../../../../../_shared/components/FormItems/PlainDatePicker"
import AppHeading from "../../../../../../_shared/components/Typography/Heading"
import { getDaySlots, isSameSlot } from "../../../../../../_shared/toolbox"
import { sortFunction } from "../DateChangeForm"

// ----------------------------------------------------------------------------

function DateForm(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { values, onValueChange, eventTypes } = props

    // const days = [
    //     {
    //         date: "2021-05-30",
    //         startTime: "08:00",
    //         endTime: "09:00",
    //     },
    //     {
    //         date: "2021-05-31",
    //         startTime: "08:00",
    //         endTime: "09:00",
    //     },
    // ]

    const days = values?.days

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    const [adding, setAdding] = useState(false)
    const [newDate, setNewDate] = useState()
    const [newStartTime, setNewStartTime] = useState("09:00")
    const [newEndTime, setNewEndTime] = useState("18:00")

    // -------------------------------------
    // Effects
    // -------------------------------------

    useEffect(() => {
        slotsEffect(values, eventTypes, onValueChange)
        //eslint-disable-next-line
    }, [values?.days, values?.eventType, eventTypes])

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function addDate() {
        setAdding(true)
    }

    function updateDays() {
        if (!values?.eventType) {
            message.error(
                "Selezionare una tipologia di evento per impostare le date"
            )
            return
        }
        const newDays = values?.days
            ? [
                  ...values?.days,
                  {
                      date: newDate,
                      startTime: newStartTime,
                      endTime: newEndTime,
                  },
              ]
            : [{ date: newDate, startTime: newStartTime, endTime: newEndTime }]
        newDays.sort(sortFunction)
        onValueChange("days")(newDays)
        handleCancel()
    }

    function deleteDay(index) {
        return () => {
            const newDays = [...values?.days]
            newDays.splice(index, 1)
            onValueChange("days")(newDays)
        }
    }

    function handleCancel() {
        setAdding(false)
        setNewDate("")
        setNewStartTime("09:00")
        setNewEndTime("18:00")
    }

    function renderDates() {
        return days?.map((day, index) => (
            <div key={index} className="date-card">
                <div className="content">
                    <div className="field">
                        <span className="label">Data</span>
                        <span className="value">{day.date}</span>
                    </div>

                    <div className="field">
                        <span className="label">Ora inizio</span>
                        <span className="value">{day.startTime}</span>
                    </div>

                    <div className="field">
                        <span className="label">Ora fine</span>
                        <span className="value">{day.endTime}</span>
                    </div>
                </div>
                <FloatingButton onClick={deleteDay(index)}>
                    <IoTrashOutline className="icn" />
                </FloatingButton>
            </div>
        ))
    }

    function renderAddDate() {
        const format = "HH:mm"
        return (
            <div className="new-date">
                <div className="field">
                    <AppHeading className="heading">Data</AppHeading>
                    <DatePicker
                        className="date-picker"
                        value={newDate}
                        onChange={(e) => setNewDate(e)}
                    ></DatePicker>
                </div>
                <div className="field">
                    <AppHeading className="heading">Ora inizio</AppHeading>
                    <TimePicker
                        className="input"
                        value={moment(newStartTime, format)}
                        format={format}
                        onChange={(_, dateString) => {
                            setNewStartTime(dateString)
                        }}
                    ></TimePicker>
                </div>
                <div className="field">
                    <AppHeading className="heading">Ora fine</AppHeading>
                    <TimePicker
                        className="input"
                        value={moment(newEndTime, format)}
                        format={format}
                        onChange={(_, dateString) => {
                            setNewEndTime(dateString)
                        }}
                    ></TimePicker>
                </div>
                <AppButton
                    onClick={updateDays}
                    uxType="primary"
                    htmlType="button"
                >
                    Conferma
                </AppButton>
                <AppButton
                    onClick={handleCancel}
                    uxType="delete"
                    htmlType="button"
                >
                    Annulla
                </AppButton>
            </div>
        )
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={props.className}>
            <div className="dates">
                {renderDates()}
                {adding && renderAddDate()}
            </div>
            {!adding && (
                <AppButton
                    onClick={addDate}
                    uxType="secondary"
                    htmlType="button"
                >
                    Nuova giornata
                </AppButton>
            )}
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

DateForm.propTypes = {
    className: PropTypes.string.isRequired,
    values: PropTypes.object,
    onValueChange: PropTypes.func,
    eventTypes: PropTypes.array,
}

DateForm.defaultProps = {}

// ----------------------------------------------------------------------------

const StyledBioForm = styled(DateForm)`
    & {
        .heading {
            margin-top: 20px;
        }
        .dates {
            margin-bottom: 40px;
            .new-date {
                margin-top: 20px;
                display: flex;
                align-items: flex-end;
                .field {
                    margin-right: 20px;
                }
                button {
                    height: 32px;
                    margin-left: 10px;
                }
            }
            .date-card {
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                .content {
                    background-color: ${({ theme }) =>
                        theme.colors.secondaryColor};
                    display: flex;
                    align-items: center;
                    /* justify-content: space-between; */
                    width: 500px;
                    height: 44px;
                    border-radius: 6px;
                    padding: 0px 15px;
                    margin-right: 15px;
                    .field {
                        margin-right: 20px;
                        .label {
                            font-size: 14px;
                        }
                        .value {
                            font-size: 16px;
                            margin-left: 5px;
                            font-weight: bold;
                            font-family: "Poppins-Bold";
                        }
                    }
                }
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default StyledBioForm

export function slotsEffect(values, eventTypes, onValueChange) {
    if (!values?.eventType || !eventTypes) {
        return
    }

    const typeId = values.eventType.id ? values.eventType.id : values.eventType
    const type = eventTypes?.find((t) => t.id === typeId)

    const oldSlots = values?.slots
    if (values?.days) {
        let slots = []
        values?.locations?.forEach((location) => {
            values?.days?.forEach((day) => {
                const newSlots = getDaySlots(
                    day.date,
                    day.startTime,
                    day.endTime,
                    location.code,
                    type.slotDuration
                )

                slots = [...slots, ...newSlots]
            })
        })
        // check if slot already existed before overwrite
        const mappedSlots = slots.map((slot) => {
            const oldSlot = oldSlots?.find((_slot) => isSameSlot(slot, _slot))
            if (oldSlot) return oldSlot
            else return slot
        })
        onValueChange("slots")(mappedSlots)
    }
}
